import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import styles from './AdminControls.module.css';
import AdminDrawer from './AdminDrawer/AdminDrawer';
import { useAppSelector } from '../../Redux/Store/Store';
import { getClientCanMandateToSubsets } from '../../Redux/Store/Slices/client';
import { navigateToLegacyMesma } from '../../Data/NavbarData';

const AdminControls = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const canMandateToSubsets = useAppSelector(getClientCanMandateToSubsets);

  // Redirect from mandate-templates if user doesn't have permission.
  // Preferences stays off the menu until it is ready to ship.
  useEffect(() => {
    if (location.pathname === '/admin/mandate-templates' && !canMandateToSubsets) {
      navigate('/admin/manage-templates/active', { replace: true });
    }
    if (location.pathname === '/admin/preferences') {
      navigate('/admin/manage-templates/active', { replace: true });
    }
  }, [location.pathname, canMandateToSubsets, navigate]);

  // Get current route to determine selected item
  const getSelectedItem = () => {
    const path = location.pathname;
    if (path.includes('create-a-template')) return 'create-template';
    if (path.includes('mandate-templates')) return 'mandate-templates';
    return 'manage-templates';
  };

  const selectedItem = getSelectedItem();

  const handleItemSelect = (itemId: string) => {
    if (itemId === 'mandate-templates') {
      navigate('/admin/mandate-templates');
    } else if (itemId === 'create-template') {
      navigate('/admin/create-a-template');
    } else if (itemId === 'manage-templates') {
      navigate('/admin/manage-templates/active');
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <AdminDrawer 
            selectedItem={selectedItem} 
            onItemSelect={handleItemSelect}
            canMandateToSubsets={canMandateToSubsets}
            onMoreAdminControlsClick={() => navigateToLegacyMesma("/AdminControls")}
          />
        </div>
        <div className={styles.rightContainer}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminControls;